import React, { useRef } from "react";
import Dropzone from "./Dropzone";
import UploadedFile from "./UploadedFile";
import styles from "./styles.module.scss";
import CryptoJS from "crypto-js";

function FileUpload({ setFile, file, user_id, setMediaFiles }) {
  const fileInputRef = useRef();

  const removeFile = () => {
    setFile(null);
    setMediaFiles("", "", "");
  };

  const handleFileChange = (e) => {
    const fileType = e.target.files[0]?.type;
    if (
      fileType &&
      (fileType.startsWith("audio/") || fileType.startsWith("video/"))
    ) {
      setFile(e.target.files[0]);
      return e.target.files[0];
    } else {
      return null;
    }
  };

  const onFileChange = (e) => {
    e.preventDefault();

    const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;

    const mediaFile = handleFileChange({
      target: { files: files },
    });

    if (mediaFile) {
      const toHash = mediaFile.name + user_id;
      const fileNameHash = CryptoJS.MD5(toHash).toString();
      const fileExtension = mediaFile.name.split(".").pop();
      setMediaFiles(fileNameHash, fileExtension);
    } else {
      alert("Only audio and video files are accepted.");
    }
  };

  return (
    <div>
      {file ? (
        <div className={styles.uploadedFiles}>
          <UploadedFile file={file} onRemove={() => removeFile()} />
        </div>
      ) : (
        <Dropzone
          onDrop={onFileChange}
          onFileClick={() => fileInputRef.current.click()}
        />
      )}

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={onFileChange}
        aria-label="Upload files"
        accept="audio/*,video/*"
      />
    </div>
  );
}

export default FileUpload;
